function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "freemiumBG_svg__b",
  x1: "0%",
  x2: "86.241%",
  y1: "8.371%",
  y2: "80.518%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#757E95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "freemiumBG_svg__a",
  width: 688,
  height: 633,
  x: 0,
  y: 0,
  rx: 5
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.08
}, /*#__PURE__*/React.createElement("mask", {
  id: "freemiumBG_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#freemiumBG_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#freemiumBG_svg__b)",
  xlinkHref: "#freemiumBG_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 633c112.141-75.128 224.619-101.616 337.433-79.465C450.248 575.686 567.103 496.508 688 316v317H0z",
  mask: "url(#freemiumBG_svg__c)"
}));

function SvgFreemiumBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 633
  }, props), _ref, _ref2);
}

export default SvgFreemiumBg;